import InfiniteScroll from 'react-infinite-scroll-component';
import './table.scss';
import OrderModel from '../../../../../base/models/appointmentManagement/dashboard/dashboardModel';
import { Empty } from 'antd';
import { getResourceTypeText, getCheckTimeText, getTimeRangeText } from './tableUtils';
import Loading from './Loading';
import SkeletonComponent from './SkeletonComponent';

interface AllTableMobileProps {
    dataList: OrderModel[];
    getModelInfo: (item: OrderModel) => void;
    appointType: number | string;
    useInfiniteScroll?: boolean;
    loadMore?: () => void;
    onRefresh?: () => Promise<void> | void;
    hasMore?: boolean;
    loading?: boolean;
    loadingMore?: boolean;
    total?: number;
}

const AllTableMobile = ({
    dataList,
    getModelInfo,
    appointType,
    useInfiniteScroll = true,
    loadMore,
    onRefresh,
    hasMore = false,
    loading = false,
    loadingMore = false,
    total = 0,
}: AllTableMobileProps) => {
    const renderStatus = (item: OrderModel) => {
        if (item.status === 5) {
            return (
                <div className="table-list-item">
                    <div className="item-title">Status</div>
                    <div className="item-info">Completed</div>
                </div>
            );
        }
        if (item.status === 3) {
            return (
                <div className="table-list-item">
                    <div className="item-title">Status</div>
                    <div className="item-info">Cancelled</div>
                </div>
            );
        }
        if (item.status === 1 || item.status === 4) {
            return (
                <div className="table-list-item">
                    <div className="item-title">Status</div>
                    <div className="all-btn">
                        <div
                            className="btn"
                            onClick={() => getModelInfo(item)}
                        >
                            Check In
                        </div>
                    </div>
                </div>
            );
        }
        if (item.status === 2) {
            return (
                <div className="table-list-item">
                    <div className="item-title">Status</div>
                    <div className="all-btn">
                        <div
                            className="btn"
                            onClick={() => getModelInfo(item)}
                        >
                            Check Out
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    };

    const renderListItem = (item: OrderModel, index: number) => (
        <div className="table-list-item-list" key={item.id || index}>
            <div className="table-list-item">
                <div className="item-title">Arrival Date</div>
                <div className="item-info">{item.booking_date || '-'}</div>
            </div>
            <div className="table-list-item">
                <div className="item-title">Name</div>
                <div className="item-info">{item.appointment_name || '-'}</div>
            </div>
            <div className="table-list-item">
                <div className="item-title">Booking Code</div>
                <div className="item-info">{item.appointment_code || '-'}</div>
            </div>
            <div className="table-list-item">
                <div className="item-title">Time</div>
                <div className="item-info">{getTimeRangeText(item)}</div>
            </div>
            <div className="table-list-item">
                <div className="item-title">Phone Number</div>
                <div className="item-info">{item.contact_mobile || '-'}</div>
            </div>
            <div className="table-list-item visitor-field-hidden">
                <div className="item-title">Visitor</div>
                <div className="item-info">{item.visitor_count || '-'}</div>
            </div>
            <div className="table-list-item">
                <div className="item-title">Booking Type</div>
                <div className="item-info">{getResourceTypeText(item.resource_type)}</div>
            </div>
            {appointType !== 3 && (
                <div className="table-list-item">
                    <div className="item-title">Check Time</div>
                    <div className="item-info">{getCheckTimeText(item)}</div>
                </div>
            )}
            {renderStatus(item)}
        </div>
    );

    const listContent = (
        <div className="table-list">
            {dataList.map(renderListItem)}
        </div>
    );

    if (!useInfiniteScroll) {
        if (loading) {
            return (
                <div className="vault-main table-main">
                    <div className="table-mobile table-mobile-pc">
                        <Loading />
                    </div>
                </div>
            );
        }
        if (!loading && dataList.length === 0) {
            return (
                <div className="vault-main table-main">
                    <div className="table-mobile table-mobile-pc">
                        <div className="loading-indicator">
                            <Empty />
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div className="vault-main table-main">
                <div className="table-mobile table-mobile-pc">
                    {listContent}
                </div>
            </div>
        );
    }

    return (
        <div className="vault-main table-main">
            <div className="table-mobile">
                <InfiniteScroll
                    dataLength={dataList.length}
                    next={loadMore || (() => {})}
                    hasMore={hasMore && !loading && !loadingMore}
                    loader={<Loading />}
                    scrollableTarget="dashboardScrollable"
                    pullDownToRefresh
                    pullDownToRefreshThreshold={80}
                    pullDownToRefreshContent={<Loading />}
                    releaseToRefreshContent={<Loading />}
                    refreshFunction={onRefresh}
                >
                    <div className="table-content-all-item">
                        {dataList.length > 0 && !loading && listContent}
                    </div>
                    {loading && <SkeletonComponent isPhone={true} />}
                    {loadingMore && <Loading />}
                    {total === 0 && !loading && (
                        <div className="loading-indicator">
                            <Empty />
                        </div>
                    )}
                    {dataList.length === total && total > 0 && !hasMore && !loading && !loadingMore && (
                        <div className="loading-indicator">
                            <span>No More</span>
                        </div>
                    )}
                </InfiniteScroll>
            </div>
        </div>
    );
};

export default AllTableMobile;
